import { faker } from '@faker-js/faker'

import { UserServiceOfferInHospitalTreatmentResponse } from '../../contracts/service-offer/UserServiceOfferInHospitalTreatment'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferInHospitalTreatmentResponse = asBuilder(
  (): UserServiceOfferInHospitalTreatmentResponse => {
    return {
      totalCount: faker.number.int(),
      treatments: faker.helpers.multiple(() => ({
        id: faker.number.int(),
        name: faker.string.uuid(),
        count: faker.number.int(),
      })),
    }
  },
)
